import { Box, Hint, Skeleton } from '@factorialco/deprecated-design-system'
import { BankingAccountLegalEntityFragment } from 'generated/resources/graphql'

import SingleChoice from 'modules/core/components/Filter/filters/SingleChoice'
import i18n from 'modules/core/lib/i18n'

export interface LegalEntitySelectorProps {
  value?: BankingAccountLegalEntityFragment
  loading?: boolean
  onChange: (le?: BankingAccountLegalEntityFragment) => void
  legalEntities: BankingAccountLegalEntityFragment[]
}

export const LegalEntitySelector = ({
  value,
  loading,
  onChange,
  legalEntities,
}: LegalEntitySelectorProps) => {
  const options = legalEntities.map((legalEntity) => ({
    label: legalEntity.legalName ?? '',
    value: legalEntity,
  }))

  return (
    <Hint.Popover.Provider steps={1} isHidden>
      <Hint.Popover
        step={1}
        title={i18n.t('finance.workspace.hints.filter_data.title')}
        description={i18n.t('finance.workspace.hints.filter_data.description')}
        actionLabel={i18n.t('finance.workspace.hints.buttons.next')}
        position="bottom right"
      >
        {loading ? (
          <Box minWidth="s140" flexDirection="row" gap="s12">
            <Skeleton height="s32" />
          </Box>
        ) : (
          <SingleChoice
            label={i18n.t('finance.workspace.legal_entity_scope.selector_label')}
            value={value}
            onValueChange={onChange}
            options={options}
          />
        )}
      </Hint.Popover>
    </Hint.Popover.Provider>
  )
}
